import { InputAdornment, TextField } from "@mui/material";

export const NmckTextField = ({
	setValue,
	adornment,
	onBlurCallback,
	onKeyDownCallback,
	disableBorder = false,
	fullWidth = true,
	sx = [],
	...props
}) => {
	return (
		<TextField
			size="small"
			fullWidth={fullWidth}
			onChange={
				setValue
					? (e) => {
							setValue(e.target.value);
					  }
					: undefined
			}
			InputProps={{
				...(adornment
					? {
							endAdornment: (
								<InputAdornment
									position="end"
									sx={{
										"& .MuiTypography-root": {
											fontSize: "13px",
										},
									}}
								>
									{adornment}
								</InputAdornment>
							),
					  }
					: {}),
			}}
			sx={[
				{
					"& .MuiOutlinedInput-input": {
						fontSize: "13px",
						paddingTop: "6px",
						paddingBottom: "6px",
						height: "18px",
					},
					"& .MuiInputLabel-sizeSmall": {
						fontSize: "13px",
					},
					"& .MuiInputLabel-sizeSmall[data-shrink='false']": {
						transform: "translate(14px, 5px) scale(1)",
					},
					"& .MuiInputLabel-sizeSmall.Mui-focused": {
						transform: "translate(14px, -9px) scale(0.75)",
					},
					"& legend": {
						fontSize: "10px",
					},
					"& .MuiOutlinedInput-notchedOutline": {
						height: "32px",
						...(disableBorder ? { border: "none" } : {}),
					},
				},
				...(Array.isArray(sx) ? sx : [sx]),
			]}
			onBlur={() => onBlurCallback?.()}
			onKeyDown={(e) => {
				if (["Enter", "NumpadEnter"].includes(e.code)) {
					onKeyDownCallback?.();
				}
			}}
			{...props}
		/>
	);
};
